import * as React from 'react';
import { Theme } from '@mui/material';
import { dateSort, nullEmptyBottomSort, numberSort } from 'components/LrGrid';
import { ICellRendererParams } from 'ag-grid-enterprise';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { Tooltip } from '@mui/material';
import { STATUS_TYPES } from '../../../constants';

// CP/GL-specific base column definitions
export const PPBaseColumnDefs = (theme: Theme) => [
    {
        headerName: 'ID',
        field: 'id',
        cellStyle: { textAlign: 'left' },
        comparator: numberSort,
        cellRenderer: (params: ICellRendererParams) => {
            const tiv = params.data.maxLocationTiv ? parseFloat(params.data.maxLocationTiv.replace(/[^0-9.]/g, '')) : 0;
            const showThresholdWarning = ['WARNING_TRIGGERED', 'BLOCKING_TRIGGERED'].includes(
                params.data.isReferralTriggered
            );
            let tooltipTitle = '';
            let showIcon = false;
            let noticeIcon = <></>;
            if (params.data.isExpired) {
                showIcon = true;
                tooltipTitle = 'This submission has expired!';
                noticeIcon = <EventBusyIcon style={{ color: theme.palette.error.main }} />;
            } else if (showThresholdWarning) {
                showIcon = true;
                tooltipTitle = "This Submission's has encountered a referral trigger!";
                noticeIcon = (
                    <ReportProblemOutlinedIcon
                        style={{
                            color:
                                params.data.isReferralTriggered === 'WARNING_TRIGGERED'
                                    ? theme.palette.warning.main
                                    : theme.palette.error.main,
                        }}
                    />
                );
            }
            return (
                <>
                    {params.data.isRenewal ? (
                        <Tooltip title={'Renewal Submission.'}>
                            <span
                                style={{
                                    borderLeft: `3px solid ${theme.palette.info.main}`,
                                    paddingLeft: '6px',
                                    marginLeft: '-9px',
                                }}
                            >
                                {params.value}
                            </span>
                        </Tooltip>
                    ) : (
                        params.value
                    )}
                    {showIcon && (
                        <div style={{ position: 'absolute', top: '5px', left: '65px' }}>
                            <Tooltip title={tooltipTitle}>{noticeIcon}</Tooltip>
                        </div>
                    )}
                </>
            );
        },
    },
    {
        headerName: 'Date Submitted',
        field: 'dateSubmitted',
        comparator: dateSort,
    },
    {
        headerName: 'Effective Date',
        field: 'effectiveDate',
        sort: 'desc',
        comparator: dateSort,
    },
    {
        headerName: 'Named Insured',
        field: 'firstNameInsured',
    },
    {
        colId: 'Status',
        headerName: 'Status',
        cellRenderer: (params: ICellRendererParams) => {
            // if we are in ready for UW review status, then check the uw review status to show that
            if (params.data.uwStatus?.narrative) {
                return (
                    <Tooltip title={params.data.uwStatus.narrative}>
                        <div>{params.value}</div>
                    </Tooltip>
                );
            }
            return params.value;
        },
        valueGetter: (params: any) => {
            if (
                params.data.statusType.code === STATUS_TYPES.READY_FOR_UNDERWRITING &&
                params.data.uwStatus?.statusDisplayName
            ) {
                return params.data.uwStatus.statusDisplayName;
            } else {
                return params.data.statusType.displayValue;
            }
        },
    },
    {
        headerName: 'PQ Score',
        field: 'pqScore',
        comparator: nullEmptyBottomSort,
    },
    {
        headerName: 'Endorsement',
        field: 'isEndorsement',
        cellDataType: false,
        valueFormatter: ({ value }: any) => {
            value = typeof value === 'string' ? value === 'true' : value;
            return value ? 'Yes' : 'No';
        },
    },
    {
        headerName: 'TIV',
        field: 'totalInsurableValue',
    },
    {
        headerName: '# Locations',
        field: 'numLocations',
    },
    {
        headerName: 'Agent',
        field: 'agentName',
    },
];
